/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface JiraStatusSyncReverseStatusMapping
 */
export interface JiraStatusSyncReverseStatusMapping {
    /**
     * 
     * @type {string}
     * @memberof JiraStatusSyncReverseStatusMapping
     */
    jiraStatusName: string;
    /**
     * 
     * @type {string}
     * @memberof JiraStatusSyncReverseStatusMapping
     */
    clearflaskStatusId: string;
}

export function JiraStatusSyncReverseStatusMappingFromJSON(json: any): JiraStatusSyncReverseStatusMapping {
    return {
        'jiraStatusName': json['jiraStatusName'],
        'clearflaskStatusId': json['clearflaskStatusId'],
    };
}

export function JiraStatusSyncReverseStatusMappingToJSON(value?: JiraStatusSyncReverseStatusMapping): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'jiraStatusName': value.jiraStatusName,
        'clearflaskStatusId': value.clearflaskStatusId,
    };
}


